import { render, staticRenderFns } from "./EditPreservation.vue?vue&type=template&id=0deecbbc&"
import script from "./EditPreservation.vue?vue&type=script&lang=ts&"
export * from "./EditPreservation.vue?vue&type=script&lang=ts&"
import style0 from "./EditPreservation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports